export default __webpack_public_path__ + "static/sketch-8e3f54fb346ba9b5e601117bc71c8089.png";